export const onlyNumbers = (str: string, integersOnly = false): string => {
  if (integersOnly) {
    return str.replace(/[^\d]+/g, '');
  } else {
    return str.replace(/[^\d.]+|(?<!\d)\.(?!\d)|\.(?=\d*\.)/g, '');
  }
};
